import { render, staticRenderFns } from "./ConversionEditTable.vue?vue&type=template&id=0672e73e&scoped=true"
import script from "./ConversionEditTable.vue?vue&type=script&lang=ts"
export * from "./ConversionEditTable.vue?vue&type=script&lang=ts"
import style0 from "./ConversionEditTable.vue?vue&type=style&index=0&id=0672e73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672e73e",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/client-settings/conversion/conversion-edit-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2Fconversion%2FConversionEditTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports